import React from 'react';
import { LegalLayout } from '@/components/layout/LegalLayout';

export function PrivacyPage() {
  return (
    <LegalLayout title="Privacy Policy" lastUpdated="May 12, 2026">
      <h2>1. Information Collection</h2>
      <p>
        The Scriptorium collects only the essential data required to facilitate the editorial process. This includes your scribe credentials, manuscript history, and interaction logs with the AI Forge.
      </p>

      <h2>2. Manuscript Confidentiality</h2>
      <p>
        All drafts and archived works are encrypted within your private vault. DocForge personnel do not access your manuscripts unless explicitly requested for technical restoration or structural support.
      </p>

      <h2>3. AI Training Disclosure</h2>
      <p>
        The Scriptorium utilizes localized models. Your manuscripts are NOT used to train public global models, ensuring the unique linguistic signature of your work remains exclusive to your account.
      </p>

      <h2>4. Third-Party Integrations</h2>
      <p>
        We utilize Better Auth for secure credential management and OpenRouter for engine processing. Data shared with these entities is limited to what is strictly necessary for their function.
      </p>

      <h2>5. Right to Erasure</h2>
      <p>
        Every scribe has the right to permanently dissolve their manuscripts and credentials from the Scriptorium vaults. This action is irreversible.
      </p>
    </LegalLayout>
  );
}
